export const ACTIVE = 'active';
export const AUTHORIZING = 'authorizing';
export const BANNED = 'banned';
export const DELETED = 'deleted';
export const INITIALIZED = 'initialized';
export const READY = 'ready';
